import { SET_SOURCE_SCHEMA_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCE_SCHEMA_SETTINGS, {
  filterValue: 'ALL',
  dataSearchTerm: '',
  eventPropertiesSearchTerm: '',
  pageSize: 50,
  currentPage: 1,
  timeframe: 7,
  pendingDisableSourceDefault: null,
  confirmingDisableSourceDefault: false,
  sortProperty: 'lastSeenAt',
  sortDirection: 'desc',
  blockedEventForwardingEnabled: null,
  blockedEventForwardingSourceId: null,
  confirmingBlockedEventForwarding: false,
  confirmingBlockedEventDiscarding: false,
  violationForwardingEnabled: null,
  violationForwardingSourceId: null,
  confirmingViolationForwarding: false,
  confirmingViolationDiscarding: false,
  confirmingSchemaUpload: false,
  schemaUploadFile: null,
  schemaUploading: false,
  schemaUploadResult: null,
  bundledIntegrationsDialogVisible: false
})
